import React from 'react'
import { ClaimNotification } from '@/organisms/ClaimCollectibleButton/ClaimNotification'
import { useTranslate } from '@/utils/translate/translate-client'

interface ClaimNotificationsProps {
  isChosenSubscriber?: boolean
  isChosenPiffer?: boolean
  isChosenInvestor?: boolean
}

export const ClaimNotifications: React.FC<ClaimNotificationsProps> = ({
  isChosenSubscriber,
  isChosenPiffer,
  isChosenInvestor,
}) => {
  const { t } = useTranslate('account')

  return (
    <div className="mx-auto mt-8 flex w-fit flex-col gap-4">
      <ClaimNotification
        checked={isChosenSubscriber}
        type="golden-scene"
        claimedTitle={t('pifingMonthly', 'Paying it Forward Monthly')}
        unclaimedTitle={t('startPifingMonthly', 'Pay it Forward Monthly')}
      />
      <ClaimNotification
        checked={isChosenPiffer}
        type="collectible-scene"
        claimedTitle={t('contributedToPIF', 'Contributed to Pay it Forward')}
        unclaimedTitle={t('pif', 'Pay it Forward')}
      />
      <ClaimNotification
        checked={isChosenInvestor}
        type="collectible-scene"
        claimedTitle={t('invested2018', 'Invested in 2018')}
        canEarn={false}
      />
    </div>
  )
}
